import Eev from 'eev';
import globalEventName from './globalEventName';
import mutationTypes from './store/mutation-types';
import actionTypes from './store/action-types';

function initGlobalStore (store) {
  const eev = new Eev();

  let globalEventDistributor = store.state.globalEventDistributor;
  let storeDataMapping = globalEventDistributor.storeDataMapping;
  
  Object.keys(storeDataMapping).forEach((name) => {
    store.state[name] = storeDataMapping[name];
  });
  
  eev.on(globalEventName.UPDATE_IS_CREATE_PAGE, (isCreatePage) => {
    store.commit(mutationTypes.SET_IS_CREATE_PAGE, isCreatePage);
  });
  
  eev.on(globalEventName.UPDATE_IS_SHOW_REGION_SELECT, (isShowRegion) => {
    store.commit(mutationTypes.SET_IS_SHOW_REGION_SELECT, isShowRegion);
  });

  eev.on(globalEventName.UPDATE_ACCOUNT_REMAINDER, () => {
    store.dispatch(actionTypes.GET_ACCOUNT_REMAINDER);
  });

 eev.on(globalEventName.UPDATE_MESSAGE_COUNT, () => {
   store.dispatch(actionTypes.GET_MESSAGE_COUNT);
  });

 eev.on(globalEventName.UPDATE_UNREAD_MESSAGE, () => {
   store.dispatch(actionTypes.GET_UNREAD_MESSAGE);
  });
  
  store.state.globalEventDistributor.registerStore(eev);
}

export default initGlobalStore;